import { getAxiosPyrgosConfig } from "../../../../common/pyrgos";
import type { IApiClientService } from "../../../../services/ApiClient/ApiClientService.interface";
import AxiosApiClientInstance from "../../../../services/AxiosApiClientInstance/AxiosApiClientInstance";
import type { IAssistantRemoteDataSource } from "./assistant-remote.datasource.interface";

export class AssistantRemoteDataSource implements IAssistantRemoteDataSource {
  private readonly _OPTIONS = getAxiosPyrgosConfig();
  private readonly _STORE_PROMPT_URL = "/assistants/ask-within-session/store-prompt";

  constructor(private readonly _client: IApiClientService = new AxiosApiClientInstance()) {}

  public async storePrompt(prompt: string): Promise<void> {
    await this._client.post(this._STORE_PROMPT_URL, { question: prompt }, this._OPTIONS);
  }
}
